import { baseApi } from '../baseApi';

export const AuricsuteItemApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    // 🔹 1. API for Item Group
    searchItemGroup: builder.mutation({
      query: (txt = '') => ({
        url: `/api/method/frappe.desk.search.search_link`,
        method: 'POST',
        body: {
          doctype: 'Item Group',
          filters: [["Item Group", "docstatus", "!=", 2]],
          reference_doctype: 'Item',
          txt: txt,
        },
      }),
    }),

    // 🔹 2. API for GST HSN Code
    searchHSNCode: builder.mutation({
      query: (txt = '') => ({
        url: `/api/method/frappe.desk.search.search_link`,
        method: 'POST',
        body: {
          doctype: 'GST HSN Code',
          reference_doctype: 'Item Group',
          txt: txt,
        },
      }),
    }),

    // 🔹 3. API for Brand
    searchBrand: builder.mutation({
      query: (txt = '') => ({
        url: `/api/method/frappe.desk.search.search_link`,
        method: 'POST',
        body: {
          doctype: 'Brand',
          reference_doctype: 'Item',
          txt: txt,
        },
      }),
    }),

    // 🔹 4. API for UOM
    searchUOM: builder.mutation({
      query: (txt = '') => ({
        url: `/api/method/frappe.desk.search.search_link`,
        method: 'POST',
        body: {
          doctype: 'UOM',
          ignore_user_permissions: 0,
          reference_doctype: 'UOM Conversion Detail',
          page_length: 10,
          txt: txt,
        },
      }),
    }),

    // 🔹 5. API for Item Tax Template
    searchItemTaxTemplate: builder.mutation({
      query: (txt = '') => ({
        url: `/api/method/frappe.desk.search.search_link`,
        method: 'POST',
        body: {
          doctype: 'Item Tax Template',
          ignore_user_permissions: 0,
          reference_doctype: 'Item Tax',
          page_length: 10,
          txt: txt,
        },
      }),
    }),

    // 🔹 6. API for Tax Category
    searchTaxCategory: builder.mutation({
      query: (txt = '') => ({
        url: `/api/method/frappe.desk.search.search_link`,
        method: 'POST',
        body: {
          doctype: 'Tax Category',
          ignore_user_permissions: 0,
          reference_doctype: 'Item Tax',
          page_length: 10,
          txt: txt,
        },
      }),
    }),
  }),
});

export const { 
  useSearchItemGroupMutation, 
  useSearchHSNCodeMutation, 
  useSearchBrandMutation,
  useSearchUOMMutation,
  useSearchItemTaxTemplateMutation,
  useSearchTaxCategoryMutation
} = AuricsuteItemApi;
